import { GroupPermissionAttached } from "../../group/grp_resource";
import { PermissionSet } from "../../rbac/permission_set";
import {
  PortalAllPermissions,
  ProcManagementAllPermissions,
} from "../../rbac/rbac";
import { Procedure, ProcedureDetail } from "./types";

export class ProcedureDetailsGroupPermissionAttached
  implements GroupPermissionAttached
{
  private procedure: ProcedureDetail | Procedure;

  constructor(procedure: ProcedureDetail | Procedure) {
    this.procedure = procedure;
  }

  resolvePermission(groupId?: string): PermissionSet {
    return new PermissionSet(
      this.procedure?.jurisdiction?.groupId &&
      this.procedure?.jurisdiction?.groupId === groupId
        ? [...ProcManagementAllPermissions, ...PortalAllPermissions]
        : [],
    );
  }
}
